import { LocalizedTypography } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { Divider, Spinner, Tag, Stack, Toggle } from '@optimus-web/core';
import { Date, LocalizedText, DateService, useDateTimeLocalizationInfo } from '@mews/framework';

interface FeatureToggleProps {
    dataTestId?: string;
    isActive: boolean;
    isDisabled: boolean;
    isMulticurrencyServiceEnabled: boolean;
    label: Mews.TextKey;
    multicurrencyStartDate: Date | null;
    onChange: (checked: boolean) => void;
    shouldShowSpinner: boolean;
}

export const FeatureToggle = ({
    dataTestId,
    isActive,
    isDisabled,
    isMulticurrencyServiceEnabled,
    label,
    multicurrencyStartDate,
    onChange,
    shouldShowSpinner,
}: FeatureToggleProps) => {
    const localizationInfo = useDateTimeLocalizationInfo();
    const textVariant = isActive ? 'primary' : 'secondary';

    return (
        <>
            <Stack distribution="space-between">
                <LocalizedTypography
                    as="h3"
                    textKey={label}
                    textStyle="bodyLargeStrong"
                    variant={isDisabled ? 'tertiary' : textVariant}
                />

                <Stack spacing="100" itemAlignment="center">
                    {shouldShowSpinner && <Spinner size="small" />}

                    {isActive && multicurrencyStartDate && !isMulticurrencyServiceEnabled && (
                        <Tag variant="primary">
                            <LocalizedText
                                textKey={TextKey.MulticurrencySettingsFeatureToggleTagText}
                                substitutes={{
                                    date: DateService.toShortMonthDayString(multicurrencyStartDate, localizationInfo),
                                }}
                            />
                        </Tag>
                    )}

                    <Toggle
                        data-test-id={dataTestId}
                        checked={isActive}
                        disabled={isDisabled}
                        onChange={(e_, value) => onChange(value)}
                    />
                </Stack>
            </Stack>

            <Divider />
        </>
    );
};
